

import React, { Component } from 'react';
/*
import SupportingText from '../../common/supportingText/SupportingText';
*/
import JournalistsPage from '../../components/journalists/containers/journalistsPageContainer';
import HeaderTags from '../../common/headerTags/HeaderTags';
import { getJournalistsData } from '../../components/journalists/actions/journalistsActions';

const headerTags = {
    title: 'Jornalistas - Conheça nossos jornalistas', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Conheça mais sobre os jornalistas que escrevem as notícias mais atuais da música e do mundo.',
        keywords: 'jornalistas, imprensa, noticias, cotidiano, economia, musica, mundo, politica, saúde, tecnologia',
        'og:title': 'Jornalistas - Conheça nossos jornalistas',
        'og:description': 'Conheça mais sobre os jornalistas que escrevem as notícias mais atuais da música e do mundo.',
        'og:image': 'https://a1media.antena1.com.br/image/share/jornalistas.png',
    },
};

/*
const supportingTextInfo = {
    title: 'JORNALISMO ANTENA 1 - NOTÍCIAS ATUAIS DE QUALIDADE',
    description: `O nosso time de jornalistas realiza um trabalho constante de pesquisa e apuração, trazendo sempre os principais
        acontecimentos tanto em âmbito nacional, quanto internacional. Além de acompanhar de perto tudo o que ocorre no universo
        musical para oferecer detalhes precisos das novidades do setor. A equipe, também, já conversou pessoalmente com grandes nomes
        da música internacional, como Laura Pausini, Billy Paul... E está sempre disposta a correr atrás da entrevista com o seu
        artista favorito. Outro diferencial é o olhar sempre acurado para os portais de notícias do exterior, visando divulgar sempre
        em primeira mão no país as novidades e inovações nas áreas de saúde, cotidiano, política, mundo, economia e tecnologia.`,
};
*/

class Jornalistas extends Component {
    static fetchData(store) {
        return store.dispatch(getJournalistsData());
    }

    render() {
        return (
            <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <JournalistsPage />
                {/*
                <SupportingText title={supportingTextInfo.title} description={supportingTextInfo.description} />
                */}
            </div>
        );
    }
}

export default Jornalistas;
